/**
 * userInfo 将用户信息保存起来
 * 	time 	时间戳
 * 	name 	名字(可以区分是否提交过信息，客服对话可以使用)
 * 	accept 	是否接受隐私条款(决定接受隐私条款框是否显示)
 * */

class UserInfo{
	constructor() {
		this.key = 'XITO_USER_IFON';
	    this.data = {};
		this.getData();
	}
	getData() {
		this.data = JSON.parse(localStorage.getItem(this.key) || '{}');
		return this.data;
	}
	setData(data = {}) {
		data['time'] = Date.parse(new Date()) / 1000;
		this.data = Object.assign(this.data, data);
		localStorage.setItem(this.key, JSON.stringify(this.data));
	}
}

export default new UserInfo